import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export async function uploadStatement(file, password = null) {
    const form = new FormData();
    form.append("file", file);
    if (password) form.append("password", password);
    const res = await client.post("/statements/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function getUploadJob(id) {
    const res = await client.get(`/statements/upload-jobs/${id}`);
    return res.data;
}

export async function getStatement(id) {
    const res = await client.get(`/statements/${id}`);
    return res.data;
}

export async function applyEdits(id, edits, text_edits = [], free_text_edits = [], metadata_override = null) {
    const res = await client.post(`/statements/${id}/edit`, { edits, text_edits, free_text_edits, metadata_override });
    return res.data;
}

export async function resetEdits(id) {
    const res = await client.post(`/statements/${id}/reset`);
    return res.data;
}

export async function startExportJob(id) {
    const res = await client.post(`/statements/${id}/export-jobs`);
    return res.data;
}

export async function getExportJob(id) {
    const res = await client.get(`/statements/export-jobs/${id}`);
    return res.data;
}

export function originalPdfUrl(id) {
    return `${API}/statements/${id}/original`;
}

export function editedPdfUrl(id) {
    return `${API}/statements/${id}/edited`;
}

export function exportPdfUrl(id, format = null) {
    return format ? `${API}/statements/${id}/export?format=${format}` : `${API}/statements/${id}/export`;
}

export function downloadExportedPdf(id, fallbackFilename, format = null) {
    const url = exportPdfUrl(id, format);
    let filename = fallbackFilename || (format === "zip" ? "statement.zip" : "statement.pdf");
    if (!filename.toLowerCase().endsWith(".pdf") && format !== "zip" && format !== "rar") {
        filename += ".pdf";
    }
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
        try {
            document.body.removeChild(a);
        } catch {
            // ignore
        }
    }, 5000);
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/** Poll until edited PDF cache is ready (server returns 202 while generating). */
export async function waitForEditedPdf(id, { maxAttempts = 300, intervalMs = 1000 } = {}) {
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
        const res = await fetch(editedPdfUrl(id));
        if (res.status === 200) {
            return true;
        }
        if (res.status !== 202) {
            let detail = `Edited PDF request failed (${res.status})`;
            try {
                const body = await res.json();
                detail = body.detail || body.message || detail;
            } catch {
                // ignore JSON parse errors
            }
            throw new Error(detail);
        }
        await sleep(intervalMs);
    }
    throw new Error("Edited PDF is taking longer than expected. Please try again.");
}
